import { pick } from 'lodash';
import * as yup from 'yup';

import { translations } from 'locales/i18n';

export const listingValidationSchema = t => ({
  title: yup.string().required(t(translations.validation.required())),
  offerText: yup
    .string()
    .min(150, t(translations.validation.minChars(), { min: 150 }))
    .required(t(translations.validation.required())),
  type: yup
    .string()
    .oneOf(['study', 'flat', 'belongings'])
    .required(t(translations.validation.required())),
  address: yup.string(),
  email: yup.string().required(),
  phone: yup.string(),
  startDate: yup.date().required(t(translations.validation.required())),
  endDate: yup.date().notRequired().nullable(),
  photos: yup.mixed()
});

export const listingInitialValues = (listing, user) =>
  listing
    ? {
        ...pick(listing, [
          'id',
          'title',
          'offerText',
          'type',
          'address',
          'startDate',
          'endDate',
          'email',
          'phone'
        ])
      }
    : {
        title: '',
        offerText: '',
        type: 'study',
        address: '',
        startDate: new Date(),
        endDate: null,
        email: user.email || '',
        phone: '',
        photos: []
      };
